/** Locate an absolute time within aligned values and timestamps. */
export function interpolationAtTime(valueCount, timestamps, time) {
    const count = Math.min(Math.max(0, Math.floor(valueCount)), timestamps.length);
    if (count === 0)
        return null;
    if (time <= timestamps[0])
        return { from: 0, to: 0, fraction: 0 };
    if (time >= timestamps[count - 1])
        return { from: count - 1, to: count - 1, fraction: 0 };
    let from = 0;
    let to = count - 1;
    while (to - from > 1) {
        const middle = (from + to) >> 1;
        if (timestamps[middle] <= time)
            from = middle;
        else
            to = middle;
    }
    const start = timestamps[from];
    const end = timestamps[to];
    return { from, to, fraction: end === start ? 0 : (time - start) / (end - start) };
}
